import React from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { ChangeAmountForm } from './changeAmountForm/component'
import { useDeposit } from '../../edit'
import { setChangedAmountData, setError } from './changeAmountForm/model'
import { transactionRequestStatus } from '../../../const'

type Props = {
  disabled?: boolean
}

export const ChangeAmountsModal: React.FC<Props> = ({ disabled }) => {
  const [isVisible, setVisible] = React.useState(false)
  const {
    deposit: {
      initialAmount,
      initialCurrency,
      clientAmount,
      clientCurrency,
      exchangeRate,
      companyAmount,
      companyCurrency,
      companyCommission,
      clientCommission,
      innerCommission,
      initialAmountUsd,
      status,
    },
  } = useDeposit()

  return (
    <>
      {[
        transactionRequestStatus.pendingManager(),
        transactionRequestStatus.questions(),
        transactionRequestStatus.missingInformation(),
        transactionRequestStatus.fundsReserved(),
        transactionRequestStatus.accepted(),
      ].includes(status) && (
        <CButton
          onClick={() => setVisible(true)}
          disabled={disabled}
          className="mb-3"
        >
          Change amounts
        </CButton>
      )}
      {isVisible && (
        <CModal
          visible={isVisible}
          onClose={() => {
            setVisible(false)
            setChangedAmountData(null)
          }}
          size="xl"
        >
          <CModalHeader>
            <CModalTitle>Change amounts</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <ChangeAmountForm
              initialData={{
                initialAmount,
                initialCurrency,
                clientAmount,
                clientCurrency,
                exchangeRate,
                companyAmount,
                companyCurrency,
                companyCommission,
                clientCommission,
                innerCommission,
                initialAmountUsd,
              }}
              transactionStatus={status}
              onClose={() => {
                setVisible(false)
                setChangedAmountData(null)
                setError({
                  message: '',
                  code: 0,
                })
              }}
            />
          </CModalBody>
        </CModal>
      )}
    </>
  )
}
